import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loader from "../../../lib/ui/loader/Loader";
import { toast } from 'react-toastify';
import { getClinicLicenceByEmail } from "../../../actions/users";


const ConfirmClinicPayment=(props)=>{

    // const location = useLocation();

    //const { signaler } = useContext(SignalerCtx);

    const history = useHistory();

    // const [active,setActive]=useState()
   

    // const [num,setNum]=useState()
    const [loading,setLoading]=useState(true)

//    const [count,setCount]=useState(0)

//    const [id,setId]=useState("")

   const searchParams = new URLSearchParams(window.location.search);
    const email = searchParams.get('email');



    //    useInterval(()=>{
    //     let num = Math.floor(Math.random() * 101);






    //         if (count>3) {setLoading(false); 
    //             console.log("Something Went Wrong !")
    //             }
            

    //         // if(num%2!==0){setLoading(false);setNum("Success!"); }
    //         // else if (num<10) {setLoading(false);setNum("Failed");}
    //         // else if (count>2) {setLoading(false); setNum("Initiated")}
            
    //         setCount(count+1)

            

                

        
        
    //     },loading ? 10000:null)

    useEffect(() => {
        // if(email && email!==""){

        
        setLoading(true)
        setTimeout(() => {
            getClinicLicenceByEmail(email).then((res)=>{
                if(res.status){
                    if(res.data && res.data.subdomain){
    
                        setLoading(false);
                        // setActive("BS")
                        toast.success("Clinic Created Successfully !", {
                            position: toast.POSITION.TOP_RIGHT
                        })
    
                       res.data.clinicName && toast.success(`Welocome to ${res.data.subdomain} !`, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                        
                        window.open(`https://${res.data.subdomain}${process.env.REACT_APP_domainURL}`, "_self")
                        //setNum("Success!");
    
                    } 
                    // else if (res.data && res.data.licensed) {setLoading(false);
                    //             setActive("FA")
                    //             toast.error("Clinic Creation Failed", {
                    //                 position: toast.POSITION.TOP_RIGHT
                    //             })
                    //             history.push("/payment-failure")
                    //         }
                //     else if (count>3) {setLoading(false);
    
                //         toast.success("Subdomain is being configured !", {
                //             position: toast.POSITION.TOP_RIGHT
                //         })
    
                //         toast.success("You will be notified via sms and email !", {
                //             position: toast.POSITION.TOP_RIGHT
                //         })
    
                //         history.push("/")
                        
                //         //setNum("Initiated")
                // }
                }else {
                    setLoading(false);
                    window.location.reload();
                    history.push("/")
                }
    
                // else if (count>3) {setLoading(false); 
                //     console.log("Something Went Wrong !")
                //     }
    
            }).catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.error, {
                    position: toast.POSITION.TOP_RIGHT
                })
            })
        }, 8000);
        // }else{
        //     window.location.reload()
        // }
    }, [email]);

  


    return(
        <div>
                      
           {loading && <Loader/> }
          
           {/* {(active ==="BS" || active ==="INI") &&  <BookingStatus active={active} formData={props.history.location.state.formData} doctorData={props.history.location.state.doctorData} />}
           {active ==="INI" &&  <BookingStatus active={active} formData={props.history.location.state.formData} doctorData={props.history.location.state.doctorData} /> } */}
        </div>
    )
}


export default ConfirmClinicPayment